export default __webpack_public_path__ + "media/src/assets/images/noImg-abe7b43429cdd79650335532c564c689.png";